import e from "react";
const f = () => {
  const [t, s] = e.useState({}), [o, a] = e.useState(!1);
  return e.useEffect(() => {
    function n(i) {
      const { message: r, consentStatuses: c } = i.data;
      r === "consent_given" && s(c);
    }
    return window.addEventListener("message", n), () => window.removeEventListener("message", n);
  }, []), e.useEffect(() => {
    typeof navigator > "u" || a(!!navigator.globalPrivacyControl);
  }, []), { ...t, gpcEnabled: o };
};
export {
  f as u
};
